import axiosInstance from "../axiosClient";


export const generatePresignUrl = async (token,fileName, fileSize, fileType, userId,operationId) => {
    try {
        const response = await axiosInstance.post(
            `/files/upload/presigned-url`,
            {
                fileName: fileName,
                fileSize: fileSize,
                fileType: fileType,
                userId: userId,
                operationId:operationId
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllFiles = async (token,userId, operationId) => {
    try {
      const response = await axiosInstance.get(`/files/all/${userId}/${operationId}`,{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
      return response.data;
    } catch (error) {
      throw error;
    }
  };


  export const getDownloadUrl = async (token, fileId, userId ,operationId,fileName,fileType) => {
    try {
        const response = await axiosInstance.get(`/files/download/${fileId}/${userId}/${operationId}/presigned-url`,
          {
            params: {
              fileName,
              fileType
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        return response.data.presignedUrl;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status === 404) {
                throw new Error("File not found");
            } else if (error.response.status === 403) {
                throw new Error("This file has been blocked due to policy violations");
            }
        }
        throw error; 
    }
};

  export const completeMultipartUpload = async (token,operationId,fileName, userId, uploadId, parts) => {
    try {
      const response = await axiosInstance.post('/files/complete-multipart', {
        operationId,
        fileName,
        userId,
        uploadId,
        parts,
      },{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  export const abortMultipartUpload = async (token,fileId, userId, uploadId,operationId,fileName) => {
    try {
      const response = await axiosInstance.post('/files/abort-multipart', {
        fileId,
        userId,
        uploadId,
        operationId,
        fileName
      },{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
      return response.data;
    } catch (error) {
      throw error;
    }
  }; 

  // Save file metadata after upload
export const saveFileMetadata = async (token, fileId, fileName, fileSize, fileType, userId, operationId, organizationId = null) => {
  try {
    const response = await axiosInstance.post(
      `/files/save-metadata`,
      {
        fileId,
        fileName,
        fileSize,
        fileType,
        userId,
        operationId,
        organizationId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Storage availability check
export const checkStorageAvailability = async (token, userId) => {
  try {
    const response = await axiosInstance.get(
      `/files/storage/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkFileNameExists = async (token,operationId,fileName, userId) => {
  try {
    const response = await axiosInstance.get(
      `/files/exists/${fileName}/${userId}/${operationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

  // File Sharing APIs
export const shareFile = async (token,fileId, sharedWith,recipientName, sender, sharedBy,operationId,fileName,fileType) => {
  try {
      const response = await axiosInstance.post(`/files/share/${fileId}/share`, {
          sharedWith,
          recipientName,
          sender,
          sharedBy,
          operationId,
          fileName,
          fileType
      },{
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
      return response.data;
  } catch (error) {
       if (error.response && error.response.data && error.response.data.message === 'This file has been blocked due to policy violations') {
      throw new Error('This file has been blocked due to policy violations');
    } else {
      throw error;
    }
  }
};

export const requestDownloadOTP = async (shareId,recipientName,recipientId) => {
  try {
      const response = await axiosInstance.post(`/files/share/${shareId}/${recipientName}/${recipientId}/request-otp`);
      return response.data;
  } catch (error) {
    
      throw error;
  }
};

export const verifyAndDownload = async (shareId, otp,fileName,fileType,operationId) => {
  try {
      const response = await axiosInstance.post(`/files/share/download/${shareId}`, { otp,fileName,fileType,operationId });
      return response.data;
  } catch (error) {
     if (error.response && error.response.data && error.response.data.message === 'Invalid share link or file is not available') {
      throw new Error('The download link is invalid or the file is no longer available');
    } else if (error.response && error.response.data && error.response.data.message === 'This file has been blocked due to policy violations') {
      throw new Error('This file has been blocked due to policy violations');
    }else if (error.response) {
      throw new Error(error.response.data.message || 'Download failed');
    } else {
      throw new Error('Network error - please check your connection');
    }
  }
};

export const removeSharedUser = async (token, shareId) => {
  try {
    const response = await axiosInstance.delete(
      `/files/share/shared-files/${shareId}`,
      {
       
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get shared history for a file
export const getSharedHistory = async (token, fileId, ownerId) => {
  try {
    const response = await axiosInstance.get(
      `/files/share/${fileId}/shared-history`,
      {
        params: { ownerId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const unsubscribeEmail = async (email,recipientId) => {
  try {
    const response = await axiosInstance.post(
      '/files/share/unsubscribe',
      { email,recipientId }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFile = async (token, userId,operationId,fileName) => {
  try {
    const response = await axiosInstance.delete(
      `/files/delete/${userId}/${operationId}/${fileName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // Handle specific error statuses
      if (error.response.status === 404) {
        throw new Error("File not found");
      } else if (error.response.status === 403) {
        throw new Error("Unauthorized to delete this file");
      }
    }
    throw new Error("Failed to delete file");
  }
};